import React, { useContext, useState } from 'react'
import { FlagFilled } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { Drawer, Button, Input, message } from 'antd'
import { useTranslation } from 'react-i18next'
import { resolveFlag } from '../../flag-management.services'
import { formatDates } from '../../flag-management.tools'
import { HistoricalContext } from '../../../../refactory/modules/jobs/infrastructure/job-detail/historical.context'
import { useAuth } from '../../../../auth/Auth.hook'

const { TextArea } = Input

const FlagComment = Form.create()((props) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const { getJobHistorical } = useContext(HistoricalContext)
  const { userInfo } = useAuth()

  const commentFlag = (comment) => {
    if (props.flag) {
      setLoading(true)
      resolveFlag(props.flag.id, comment)
        .then((result) => {
          if (result) {
            message.success(t('jobs.flags.solved'))
            props.listFlags(props.job.id)
            getJobHistorical(props.job.id)
            props.handleFlagComments()
            props.form.resetFields()
          }
          setLoading(false)
        })
        .catch((_) => {
          setLoading(false)
        })
    }
  }

  const updateFlagComment = (event) => {
    event.preventDefault()
    props.form.validateFields((err, values) => {
      if (!err) {
        commentFlag(values.comment)
      }
    })
  }

  const { getFieldDecorator } = props.form
  const { flag } = props
  return (
    <Drawer
      className='flags-comment-drawer'
      title={t('jobs.flags.flagsComments.form.title')}
      width={500}
      onClose={props.handleFlagComments}
      visible={props.visible}
    >
      <Form layout='vertical' onSubmit={updateFlagComment}>
        <div>
          <h4>
            <FlagFilled className='flag-red' />
            <b> {flag ? t(`flags.${flag.category.name}`) : ''} </b>
            {flag ? formatDates(new Date(flag.createdAt), 'hour') : ''}
          </h4>
          {flag && flag.params && <p>{t(`flags.comments.${flag.params.comment}`) ?? ''}</p>}
        </div>
        <Form.Item label={t('jobs.flags.flagsComments.form.comment.label')}>
          {getFieldDecorator('comment', {
            rules: [{ required: true, message: t('jobs.flags.flagsComments.form.comment.message') }]
          })(<TextArea rows={4} placeholder={t('jobs.flags.flagsComments.form.comment.placeholder')} />)}
          <span>{t('jobs.flags.flagsComments.form.comment.responsible')}: </span>
          <b>
            {userInfo?.user.firstName} {userInfo?.user.lastName}
          </b>
        </Form.Item>
        <div
          style={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right'
          }}
        >
          <Button onClick={props.handleFlagComments} style={{ marginRight: 8 }}>
            {t('jobs.flags.flagsComments.form.cancel')}
          </Button>
          <Button loading={loading} htmlType='submit' type='primary'>
            {t('jobs.flags.flagsComments.form.solve')}
          </Button>
        </div>
      </Form>
    </Drawer>
  )
})

export default FlagComment
